"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRequestReferee = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.GroupRequestReferee = {
    NUMBER_100: '100',
    NUMBER_200: '200',
    NUMBER_201: '201',
    NUMBER_220: '220',
    NUMBER_221: '221',
    NUMBER_240: '240',
    NUMBER_241: '241',
};
